import { DateRangeType, TIMEFRAME, TimeframeAndIntradayType } from '../../constants/common'

interface ITimeFrame {
  value: TimeframeAndIntradayType
  label: string
  labelShort: string
}

interface ITimeframeGroup {
  label: string
  timeframes: ITimeFrame[]
}

interface IDateRange {
  value: string
  label: string
  timeframe?: TIMEFRAME
}

export const getTimeFrameGroups = (isPremium = true): ITimeframeGroup[] => {
  const premiumTimeframes: ITimeframeGroup[] = [
    {
      label: '',
      timeframes: [
        { value: TIMEFRAME.i1, label: '1 Minute', labelShort: '1M' },
        { value: TIMEFRAME.i3, label: '3 Minutes', labelShort: '3M' },
        { value: TIMEFRAME.i5, label: '5 Minutes', labelShort: '5M' },
        { value: TIMEFRAME.i10, label: '10 Minutes', labelShort: '10M' },
        { value: TIMEFRAME.i15, label: '15 Minutes', labelShort: '15M' },
        { value: TIMEFRAME.i30, label: '30 Minutes', labelShort: '30M' },
      ],
    },
    {
      label: '',
      timeframes: [
        { value: TIMEFRAME.h, label: '1 Hour', labelShort: '1H' },
        { value: TIMEFRAME.h2, label: '2 Hours', labelShort: '2H' },
        { value: TIMEFRAME.h4, label: '4 Hours', labelShort: '4H' },
      ],
    },
    {
      label: '',
      timeframes: [
        { value: TIMEFRAME.d, label: '1 Day', labelShort: 'D' },
        { value: TIMEFRAME.w, label: '1 Week', labelShort: 'W' },
        { value: TIMEFRAME.m, label: '1 Month', labelShort: 'M' },
      ],
    },
  ]

  const freeTimeframes = [
    {
      // intradayTimeframe is only for non premium users used as redirect to elite subscription
      label: '',
      timeframes: [{ value: 'intraday' as const, label: 'Intraday', labelShort: 'Intraday' }],
    },
    {
      label: '',
      timeframes: [
        { value: TIMEFRAME.d, label: '1 Day', labelShort: 'Daily' },
        { value: TIMEFRAME.w, label: '1 Week', labelShort: 'Weekly' },
        { value: TIMEFRAME.m, label: '1 Month', labelShort: 'Monthly' },
      ],
    },
  ]

  return isPremium ? premiumTimeframes : freeTimeframes
}

export const getDateRangeGroups = (isPremium = true) => {
  const rangeGroups: Array<{ label?: string; dateRanges: IDateRange[] }> = [
    {
      label: 'Days',
      dateRanges: [
        { value: DateRangeType.d1, label: '1 Day', timeframe: TIMEFRAME.i1 },
        { value: DateRangeType.d5, label: '5 Days', timeframe: TIMEFRAME.i5 },
      ],
    },
    {
      label: 'Months',
      dateRanges: [
        { value: DateRangeType.m1, label: '1 Month', timeframe: TIMEFRAME.d },
        { value: DateRangeType.m3, label: '3 Months', timeframe: TIMEFRAME.d },
        { value: DateRangeType.m6, label: '6 Months', timeframe: TIMEFRAME.d },
      ],
    },
    {
      label: 'Years',
      dateRanges: [
        { value: DateRangeType.ytd, label: 'Year to Date', timeframe: TIMEFRAME.d },
        { value: DateRangeType.y1, label: '1 Year', timeframe: TIMEFRAME.d },
        { value: DateRangeType.y2, label: '2 Years', timeframe: TIMEFRAME.w },
        { value: DateRangeType.y5, label: '5 Years', timeframe: isPremium ? TIMEFRAME.w : TIMEFRAME.m },
        { value: DateRangeType.max, label: 'Max', timeframe: TIMEFRAME.m },
      ],
    },
  ]

  return rangeGroups
}
